<template>
  <el-container class="companies">
    <el-header class="header-style">
      <el-divider content-position="left">公司管理</el-divider>
      <el-row>
        <el-col :span="9">
          <el-input style="width: auto" v-model="searchArr.company_name" size="mini" clearable placeholder="请输入公司名称筛选公司" @input="handleSearchCompanyChange" />
<!--          <el-select v-model="searchArr.company_id" filterable remote reserve-keyword placeholder="请输入公司名称筛选公司"-->
<!--            size="mini" clearable :remote-method="searchRemoteCompanyMethod" :loading="searchLoading"-->
<!--            @change="handleSearchCompanyChange">-->
<!--            <el-option v-for="searchCompany in searchCompanies" :key="searchCompany.id"-->
<!--              :label="searchCompany.company_name" :value="searchCompany.id">-->
<!--            </el-option>-->
<!--          </el-select>-->
          <el-cascader v-model="searchArr.area_park" clearable :options="areas" size="mini"
            :props="{ expandTrigger: 'hover' }" @change="handleAreaChange" :filter-method="filterOptions">
          </el-cascader>
          <el-popover placement="bottom-start" v-model="visible" width="560">
            <el-form :model="searchArr" ref="searchForm" label-width="110px">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="意向度" prop="satisfy">
                    <el-radio-group v-model="searchArr.satisfy" size="mini">
                      <el-radio-button label="1">A</el-radio-button>
                      <el-radio-button label="2">B</el-radio-button>
                      <el-radio-button label="3">C</el-radio-button>
                      <el-radio-button label="4">D</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="12">
                  <el-form-item label="公司来源" prop="company_from">
                    <el-radio-group v-model="searchArr.company_from" size="mini">
                      <el-radio-button label="0">未知</el-radio-button>
                      <el-radio-button label="1">线上</el-radio-button>
                      <el-radio-button label="2">线下</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col> -->
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="企业状态" prop="regStatus">
                    <el-checkbox-group v-model="searchArr.regStatus" size="mini">
                      <el-checkbox-button v-for="item in regStatusOptions" :label="item"
                        :key="item">{{ item }}</el-checkbox-button>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="14">
                  <el-form-item label="是否核税" prop="is_check_tax">
                    <el-radio-group v-model="searchArr.is_check_tax" size="mini">
                      <el-radio-button label="1">已核税</el-radio-button>
                      <el-radio-button label="0">未核税</el-radio-button>
                      <el-radio-button label="2">异常</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="是否自有公司" prop="self_flag">
                    <el-radio-group v-model="searchArr.self_flag" size="mini">
                      <el-radio-button label="1">是</el-radio-button>
                      <el-radio-button label="0">否</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="完成年报" prop="annual_doned">
                    <el-radio-group v-model="searchArr.annual_doned" size="mini">
                      <el-radio-button label="1" border>是</el-radio-button>
                      <el-radio-button label="2" border>否</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="委托代账(奉贤)" prop="is_trust_agent">
                    <el-radio-group v-model="searchArr.is_trust_agent" size="mini">
                      <el-radio-button label="1" border>是</el-radio-button>
                      <el-radio-button label="0" border>否</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="财税顾问">
                    <el-cascader style="width: 100%" v-model="searchArr.service_advisor_id" placeholder="请选择财税顾问"
                      :options="adminUsersLists" size="mini"
                      :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }" clearable filterable
                      :filter-method="filterOptions">
                    </el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="委托代账(静安)" prop="is_agent_acc_finance">
                    <el-radio-group v-model="searchArr.is_agent_acc_finance" size="mini">
                      <el-radio-button label="1" border>是</el-radio-button>
                      <el-radio-button label="0" border>否</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="业务员" prop="saler_id">
                    <el-cascader style="width: 100%" v-model="searchArr.saler_id" placeholder="请选择业务员"
                      :options="adminUsersLists" size="mini"
                      :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }" clearable filterable
                      :filter-method="filterOptions">
                    </el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="共享人" prop="share_ids">
                    <el-cascader style="width: 100%" v-model="searchArr.share_ids" placeholder="请选择"
                      :options="adminUsersLists" size="mini"
                      :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }" clearable filterable
                      :filter-method="filterOptions">
                    </el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="成立时间" prop="date_of_est">
                    <el-date-picker v-model="searchArr.date_of_est" type="monthrange" align="right" unlink-panels
                      range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" value-format="yyyy-MM-dd"
                      size="mini" style="width: 100%" :picker-options="pickerMonthOptions">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="网站信息" prop="web">
                    <el-radio-group v-model="searchArr.web" size="mini">
                      <el-radio-button label="1" border>有</el-radio-button>
                      <el-radio-button label="2" border>无</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item style="text-align: right">
                <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
                <el-button type="primary" @click="submitForm('searchForm')" size="mini">查询</el-button>
              </el-form-item>
            </el-form>
            <el-button slot="reference" size="mini">筛选</el-button>
          </el-popover>
        </el-col>
        <el-col :span="4" style="margin-left: -0.8rem">
          <el-select v-model="valueList" multiple filterable collapse-tags size="mini" placeholder="请选择"
            :popper-append-to-body="false" @change="handelColCange">
            <el-option v-for="(item, index) in col" :label="item.label" :value="index" :key="index"></el-option>
          </el-select>
        </el-col>
        <el-col :span="11" style="text-align: right; float: right">
          <el-popover placement="bottom" width="10" trigger="click">
            <div style="
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                align-items: center;
              ">
              <el-button type="primary" @click="changeComPark" size="mini">更换公司园区</el-button>
              <!-- <el-tooltip effect="dark" content="批量分配" placement="top">
                <el-button
                  type="warning"
                  size="mini"
                  @click="handleBatchSharer"
                  style="margin-left: 0 !important;margin-top: 0.1rem"
                  >批量分配人员</el-button
                >
              </el-tooltip> -->
              <el-upload style="display: inline-block;margin-top: 0.1rem"
                action="https://weixin.qiyehuo.com/api/compnay_com/import_share" :headers="headers"
                :show-file-list="false" :on-success="importedReturn">
                <el-button type="success" size="mini">导入共享人员</el-button>
              </el-upload>
              <el-upload style="display: inline-block;margin-top: 0.1rem"
                action="https://weixin.qiyehuo.com/api/compnay_com/import_saler" :headers="headers"
                :show-file-list="false" :on-success="importedSalerReturn">
                <el-button type="success" size="mini">导入角色人员</el-button>
              </el-upload>
              <el-upload style="display: inline-block;margin-top: 0.1rem"
                action="https://weixin.qiyehuo.com/api/compnay_com/batch_update_fields" :headers="headers"
                :show-file-list="false" :on-success="importedSalerReturn">
                <el-button type="success" size="mini">导入公司来源</el-button>
              </el-upload>
              <el-tooltip class="item" effect="dark" content="选择条件导出公司信息" placement="top">
                <el-button type="warning" style="margin-top: 0.1rem" size="mini"
                  @click="exportCompany">导出公司信息</el-button>
              </el-tooltip>
            </div>
            <el-button type="primary" size="mini" slot="reference">更多操作</el-button>
          </el-popover>
        </el-col>
      </el-row>
    </el-header>

    <el-main class="main-style">
      <el-table ref="company_table" height="calc(100vh - 276px)" :data="companies" size="medium" border
        style="width: 100%" @selection-change="handleSelectionChange" v-cloak>
        <el-table-column type="selection" width="55" fixed></el-table-column>
        <el-table-column label="公司ID" width="90" fixed>
          <template slot-scope="scope">
            <div v-if="scope.row.id">
              <span>{{ scope.row.id }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="公司名称" width="300" fixed>
          <template slot-scope="scope">
            <div style="white-space: nowrap; width: 5rem; overflow: auto">
              <el-tooltip :content="scope.row.company_name" placement="top" style="display: inline-block">
                <el-link type="primary" class="count-style" @click="handleCompanyInfoOpen(scope.row.id)">{{
          scope.row.company_name }}</el-link>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="复制" placement="top">
                <i class="el-icon-document-copy" style="margin-left: 0.1rem; cursor: pointer"
                  @click="copySome(scope.row.company_name)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="生成二维码" placement="top">
                <i class="el-icon-camera-solid" style="margin-left: 0.1rem; cursor: pointer; color: #409eff"
                  @click="createQrCode(scope.row.company_name, scope.row.id)"></i>
              </el-tooltip>
              <template v-if="scope.row.self_flag === 1">
                <el-tooltip class="item" effect="dark" content="当前公司为自家公司" placement="top">
                  <i class="el-icon-s-flag" style="margin-left: 0.1rem; cursor: pointer; color: red"></i>
                </el-tooltip>
              </template>
              <template>
                <el-tooltip class="item" effect="dark" :content="scope.row.tag_at ? '取消置顶' : '置顶'" placement="top">
                  <i @click="handleSignToTop(scope.$index, scope.row)" style="margin-left: 0.1rem; cursor: pointer"
                    class="el-icon-star-on" :style="{ color: scope.row.tag_at ? 'red' : '' }"></i>
                </el-tooltip>
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="企业状态" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.regStatus }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column label="公司来源" width="110">
          <template slot-scope="scope">
            <el-tooltip
              content="双击修改"
              placement="top"
              v-if="!needEditStatus[scope.row.id]"
            >
              <span
                @dblclick="toEdit(scope.row.company_from, scope.row.id)"
                class="hide-style"
                >{{ scope.row.company_from }}<img class="icon-class" src="/static/edit_com_from.svg" /></span>
              </el-tooltip>
              <edit-input
                v-if="needEditStatus[scope.row.id] === true"
                :line="lineFrom"
                :cid="needCid"
                @updateLine="doUpdateLine"
                @revert="revert"
              />
          </template>
        </el-table-column> -->
        <el-table-column label="网站信息">
          <template slot-scope="scope">
            <span style="color: #409EFF; cursor: pointer" @click="showWebs(scope.row.id)">{{ scope.row.webs_count
              }}</span>
          </template>
        </el-table-column>

        <el-table-column label="意向度" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.reflect && scope.row.reflect.satisfy !== null">
              <span v-if="scope.row.reflect.satisfy === 1">A</span>
              <span v-if="scope.row.reflect.satisfy === 2">B</span>
              <span v-if="scope.row.reflect.satisfy === 3">C</span>
              <span v-if="scope.row.reflect.satisfy === 4">D</span>
            </div>
            <div v-else>
              <span></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="是否完成年报" width="155">
          <template slot-scope="scope">
            <span v-if="scope.row.annals_overd.length > 0" class="hide-style" style="color: #67c23a">{{
          scope.row.annals_overd.length > 0 ? "已完成" : "未完成" }}</span>
            <span v-else class="hide-style" style="color: red">{{ scope.row.annals_overd.length > 0 ? "已完成" : "未完成"
              }}<el-tooltip class="item" effect="dark" content="年报是否完成刷新" placement="top"><i class="el-icon-refresh"
                  @click="refreshAnnual(scope.row)"
                  style="color: #409eff; cursor: pointer; margin-left: 0.2rem"></i></el-tooltip></span>
            <el-tooltip class="item" effect="dark" content="年报是否完成,更新时间" placement="top">
              <p>
                <!-- {{ scope.row.visited_xlb_at }} -->
                <date-formatter :date-value="scope.row.visited_xlb_at"></date-formatter>
              </p>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column v-if="item.display" v-for="(item, index) in col" :key="index" :prop="item.prop"
          :label="item.label" :width="tableColumn(item.prop)">
          <template slot-scope="scope">
            <template v-if="item.prop === 'is_check_tax'">
              <span class="hide-style">{{
          // scope.row[item.prop] === 0 ? "未核税" : "已核税"
          ['未核税', '已核税', '异常'][scope.row[item.prop]]
        }}</span>
            </template>

            <div v-else-if="item.prop === 'is_trust_agent'">
              <span class="count_style" style="display: inherit">{{
          scope.row[item.prop] === 0 ? "否" : "是"
        }}</span>
            </div>

            <template v-else-if="item.prop === 'is_agent_acc_finance'">
              <span class="count_style" style="display: inherit">{{
          scope.row[item.prop] === 0 ? "否" : "是"
        }}</span>
            </template>

            <template v-else-if="item.prop === 'customer_phone'">
              <span v-if="scope.row.customer" class="count_style" style="display: inherit">
                <phone-com :comPhone="scope.row.customer.phone" :vagaryPhone="scope.row.customer.vagary_phone"
                  style="display: inline-block" />
              </span>
              <span v-else></span>
            </template>

            <template v-else-if="item.prop === 'legaler_contact'">
              <span v-if="scope.row.legaler_contact !== ''" class="count_style" style="display: inherit">
                <phone-com :comPhone="scope.row.legaler_contact" :vagaryPhone="scope.row.vagary_phone_legaler"
                  style="display: inline-block" />
              </span>
              <span v-else></span>
            </template>

            <template v-else-if="item.prop === 'date_of_est'">
              <span class="count_style" style="display: inherit">{{
          scope.row[item.prop] | dateFormat
        }}</span>
            </template>
            <template v-else>
              <span class="count_style" style="display: inherit">{{
            scope.row[item.prop]
          }}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="业务员">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="scope.row.dedicated_consultant
            .map((item) => (item.adminuser ? item.adminuser.username : ''))
            .join(', ')
          " placement="top">
              <span class="count_style">{{
          scope.row.dedicated_consultant
            .map((item) => (item.adminuser ? item.adminuser.username : ""))
            .join(", ")
        }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="130">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click.native="handleEditRow(scope.row)">编辑</el-button>
            <el-dropdown trigger="click" style="margin-left: 0.4rem; top: 0.04rem; cursor: pointer; color: #409eff">
              <span class="el-dropdown-link">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="handCallLogsOpen(scope.row)">
                  <span><img class="icon-class" src="/static/tel_record.svg" /></span>电话联系记录</el-dropdown-item>
                <el-dropdown-item @click.native="serviceIn(scope.row)"><span><img class="icon-class"
                      src="/static/edit.svg" /></span>服务事项录入</el-dropdown-item>
                <el-dropdown-item @click.native="handBindWxgroupsOpen(scope.row.id)">
                  <span><img class="icon-class" src="/static/bind.svg" /></span>微信群绑定</el-dropdown-item>
                <el-dropdown-item @click.native="
          handleWxChatOpen(scope.row.id, scope.row.company_name)
          " :disabled="scope.row.wx_work_chat_com_count > 0 ? false : true">
                  <span><img class="icon-class" src="/static/chat_record.svg" /></span>企业微信群聊天记录</el-dropdown-item>

                <el-tooltip v-if="scope.row.inFinanceTaxation === false" class="item" effect="dark" content="发起交接"
                  placement="top">
                  <el-dropdown-item @click.native="handleSwitchCheckOpen(scope.row)">
                    <span><img class="icon-class" src="/static/pass.svg" /></span>发起交接</el-dropdown-item>
                </el-tooltip>
                <el-tooltip v-else class="item" effect="dark" content="已存在于财税登记表,点击打开财务交接列表" placement="top">
                  <el-dropdown-item @click.native="$router.push('finance_switch')">
                    <span><img class="icon-class" src="/static/pass.svg" /></span>已交接</el-dropdown-item>
                </el-tooltip>
              </el-dropdown-menu>
            </el-dropdown>
          </template>

          <!--
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="修改" placement="top">
              <el-button @click.native.prevent="handleEditRow(scope.row)" type="primary" size="mini" icon="el-icon-edit"
                circle>
              </el-button>
            </el-tooltip>
            <!-- <el-tooltip class="item" effect="dark" content="电话联系记录" placement="top">
              <el-button type="primary" size="mini" icon="el-icon-phone-outline" circle
                @click="handCallLogsOpen(scope.row)"></el-button>
            </el-tooltip> -->
          <!-- <el-tooltip class="item" effect="dark" content="服务事项录入" placement="top">
              <el-button type="success" @click="serviceIn(scope.row)" size="mini" icon="el-icon-s-flag"
                circle></el-button>
            </el-tooltip> -->
          <!-- <el-tooltip class="item" effect="dark" content="微信群绑定" placement="top">
              <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline" circle
                @click="handBindWxgroupsOpen(scope.row.id)"></el-button>
            </el-tooltip> -->
          <!-- <el-tooltip class="item" effect="dark" content="企业微信群聊天记录" placement="top">
              <el-button type="warning" :disabled="scope.row.wx_work_chat_com ? false : true" @click="
                handleWxChatOpen(scope.row.wx_work_chat_com, scope.row.company_name)
                " size="mini" icon="el-icon-s-comment" circle></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="发起交接" placement="top"
              v-if="scope.row.inFinanceTaxation === false">
              <el-button type="primary" size="mini" icon="el-icon-s-operation" circle
                @click="handleSwitchCheckOpen(scope.row)"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="已存在于财税登记表,点击打开财务交接列表" placement="top"
              v-if="scope.row.inFinanceTaxation === true">
              <el-button type="success" size="mini" icon="el-icon-s-operation" circle
                @click="$router.push('finance_switch')"></el-button>
            </el-tooltip>
          </template> -->
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer-style">
      <el-pagination background class="tr mt-10" layout="total, sizes, prev, pager, next, jumper"
        :hide-on-single-page="false" :current-page="pageOption.currentPage" :page-size="pageOption.pageSize"
        :page-sizes="[10, 20, 30, 50, 100, 500]" :total="pageOption.total" @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-footer>

    <el-dialog title="" :visible.sync="ShareImportInfo" append-to-body @closed="closeSelf">
      <span slot="title" style="font-weight: bold; font-size: large; color: #409eff">导入信息</span>
      <div class="import-info-style">
        <p style="color: #67c23a; font-size: medium">共成功导入{{ successNum }}条</p>
        <p style="color: #e6a23c; font-size: medium; margin-top: 0.2rem">
          公司名称未匹配{{ unCompanys.length }}条:
        </p>
        <div style="margin-top: 0.1rem">
          <el-row gutter="20">
            <el-col :span="6" v-for="item in unCompanys" :key="item" style="margin-bottom: 0.2rem">
              <el-tooltip class="item" effect="dark" :content="item" placement="top">
                <div style="
                    width: 225px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  ">
                  {{ item }}
                </div>
              </el-tooltip>
            </el-col>
          </el-row>
        </div>
        <p style="color: #e6a23c; font-size: medium; margin-top: 0.2rem">
          后台用户名称未匹配{{ unAdminUsers.length }}条:
        </p>
        <div style="margin-top: 0.1rem">
          <el-row gutter="20">
            <el-col :span="6" v-for="item in unAdminUsers" :key="item" style="margin-bottom: 0.2rem">
              <el-tooltip class="item" effect="dark" :content="item" placement="top">
                <div style="
                    width: 225px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  ">
                  {{ item }}
                </div>
              </el-tooltip>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="批量更新业务员返回结果" :visible.sync="salerResult" append-to-body @closed="autoClose">
      <span slot="title" style="font-weight: bold; font-size: large; color: #409eff">导入结果</span>
      <div class="import-info-style">
        <p style="color: #67c23a; font-size: medium">共成功导入{{ successTotal }}条</p>
        <p style="color: #e6a23c; font-size: medium; margin-top: 0.2rem">
          公司名称未匹配：{{ failedCompanies.length }}条:
        </p>
        <div style="margin-top: 0.1rem">
          <el-row gutter="20">
            <el-col :span="6" v-for="item in failedCompanies" :key="item" style="margin-bottom: 0.2rem">
              <el-tooltip class="item" effect="dark" :content="item" placement="top">
                <div style="
                    width: 225px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  ">
                  {{ item }}
                </div>
              </el-tooltip>
            </el-col>
          </el-row>
        </div>
        <p style="color: #e6a23c; font-size: medium; margin-top: 0.2rem">
          业务员名称未匹配：{{ failedUsers.length }}条:
        </p>
        <div style="margin-top: 0.1rem">
          <el-row gutter="20">
            <el-col :span="6" v-for="item in failedUsers" :key="item" style="margin-bottom: 0.2rem">
              <el-tooltip class="item" effect="dark" :content="item" placement="top">
                <div style="
                    width: 225px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  ">
                  {{ item }}
                </div>
              </el-tooltip>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="绑定客户" :visible.sync="customerDialogVisible" width="30%" :before-close="handleCustomerClose">
      <div>
        <el-row>
          <el-col :span="24">
            <el-input size="mini" v-model="bindUserForm.bindUserId" placeholder="请输入客户id"
              @change="handleBindUserChange"></el-input>
          </el-col>
        </el-row>
        <el-row class="mt-10">
          <el-col :span="12"><span>{{ selectBindUser.name }}</span></el-col>
          <el-col :span="12"><span>{{ selectBindUser.phone }}</span></el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitBindCustomer">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="服务对接人" :visible.sync="bindDuckVisible" width="20%" :before-close="handleBindDuckClose">
      <div>
        <el-row>
          <el-col>
            <el-input width="100%" size="mini" v-model="bindDuckForm.name" placeholder="请输入服务对接人姓名"></el-input>
          </el-col>
        </el-row>
        <el-row class="mt-20">
          <el-col>
            <el-input width="100%" size="mini" v-model="bindDuckForm.phone" placeholder="请输入服务对接人手机号"></el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitBindDuck">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer :visible.sync="serviceInDrawer" direction="rtl" size="40%">
      <template slot="title">
        <span style="font-size: 0.38rem; font-weight: 700; color: #409eff">服务事项录入</span>
      </template>
      <ser-matt-in :companyId="cId" :companyName="cName" @close="closeDrawer"></ser-matt-in>
    </el-drawer>

    <el-drawer title="公司信息" :visible.sync="companyInfoDrawer" :show-close="true" :modal="false" :withHeader="true"
      :wrapperClosable="true" direction="rtl" custom-class="AIdrawer" class="AIdrawerWrapper" size="90%"
      :before-close="handleCompanyInfoBeforeClose">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyInfoId" @reloadTable="reloadTable" :checkType="checkType"></company-info>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="电话联系记录" :visible.sync="callLogsDrawer" direction="rtl" :before-close="handleCallLogsBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <call-logs :company="company" :phone="callPhone" :phone1="callPhone1" :phone2="callPhone2"
            :phone3="callPhone3"></call-logs>
        </el-row>
      </div>
    </el-drawer>
    <el-dialog title="绑定群聊" :visible.sync="bindWxDialogVisible" width="25%" :before-close="handleBindWxClose">
      <el-select style="width: 100%" v-model="wxBindFrom.groupId" filterable remote reserve-keyword placeholder="输入群名"
        size="mini" :remote-method="searchNameremoteMethod" :loading="searchChatLoading" clearable>
        <el-option v-for="(group, index) in wxGroups" :key="index" :label="group.contact_nick_name"
          :value="group.contact_wx_id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleWxBindSub">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer title="企业微信聊天记录" :visible.sync="wxChatDrawer" direction="rtl" :before-close="handleWxChatBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat :chatId="wxWorkChatId" :chatName="wxWorkchatCompany"></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="" :visible.sync="phoneFromDraw" direction="rtl" :before-close="closePhoneFromDraw" size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <make-phone :phone1="phoneFrom_phone"></make-phone>
        </el-row>
      </div>
    </el-drawer>
    <!-- 支付人详情及公司情况 结束 -->
    <!-- 沟通记录弹窗 开始-->
    <el-drawer title="沟通记录" :visible.sync="chatRecordDrawer" direction="rtl" :before-close="handleChatRecordBeforeClose"
      size="40%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <chat-record :threadId="threadId"></chat-record>
        </el-row>
      </div>
    </el-drawer>
    <!-- 沟通记录弹窗 结束-->
    <!-- <el-dialog title="公司名称二维码" :visible.sync="QrCodeDialog" :modal="false" width="20%" style="text-align: center">
        <qr-code :url="company_name_text" :content="company_name_text"/>
    </el-dialog> -->
    <el-dialog @close="close_QrCodeDialog" title="公司名称二维码" :visible.sync="QrCodeDialog" :modal="false" width="20%"
      style="text-align: center">
      <qrcode-logo :url="JSON.stringify({ company_name_text, company_id_text })" :iconurl="logoUrl" :wid="200"
        :hei="200" :imgwid="60" :imghei="60" />
    </el-dialog>
    <el-drawer title="发起交接" :visible.sync="switchOrCheckDrawer" direction="rtl"
      :before-close="closeSwitchOrCheckFromDrawer" size="60%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-form :model="formData" label-width="100px" :rules="rules" ref="formData">
          <el-form-item label="当前公司">
            <el-row>
              <el-col :span="23" style="font-size: 20px">
                {{ company_name_text }}
              </el-col>
              <!-- <el-col :span="1">
                <el-tooltip class="item" effect="dark" content="新增订单" placement="top">
                  <i class="el-icon-circle-plus"
                style="font-size: 24px; margin-top: .16rem;cursor: pointer;" @click="handleAddOrderComponents"></i>
                </el-tooltip>
              </el-col> -->
            </el-row>
          </el-form-item>

          <template v-if="formData.orderComponents.length <= 0">
            <el-form-item label="订单信息">
              <el-row :span="24">
                <el-col>
                  <span style="color: red">暂无订单信息</span>
                </el-col>
              </el-row>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item v-for="(order, index) in formData.orderComponents" :label="'订单信息 ' + (index + 1)"
              :key="index">
              <el-row :span="24">
                <el-col :span="8">
                  <el-form-item :prop="'orderComponents.' + index + '.order_num'" :rules="orderNumRules">
                    <el-input type="text" size="mini" placeholder="请输入订单编号" v-model="order.order_num" prop="order_num"
                      :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="7" :offset="1">
                  <el-form-item :prop="'orderComponents.' + index + '.service_started_at'">
                    <el-date-picker v-model="order.service_started_at" style="width: 80%" type="month" size="mini"
                      value-format="yyyy-MM" placeholder="选择服务开始时间"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item :prop="'orderComponents.' + index + '.service_ended_at'">
                    <el-date-picker v-model="order.service_ended_at" style="width: 80%" type="month" size="mini"
                      value-format="yyyy-MM" placeholder="选择服务结束时间"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="删除订单" placement="top">
                    <i class="el-icon-remove" style="font-size: 24px; margin-top: 0.16rem; cursor: pointer"
                      @click="handleRemoveOrderComponents(index)"></i>
                  </el-tooltip>
                </el-col>
              </el-row>
            </el-form-item>
          </template>
          <!-- <el-form-item label="所属财务" prop="subsidiary_finance">
            <el-select
              v-model="formData.subsidiary_finance"
              placeholder="请选择财务人员"
              filterable
              clearable
              size="mini"
            >
              <el-option
                v-for="user in adminUsers"
                :key="user.id"
                :label="user.username"
                :value="user.id"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="是否零申报">
            <el-radio-group v-model="formData.is_zero_declare" size="mini">
              <el-radio-button :label="0">否</el-radio-button>
              <el-radio-button :label="1">是</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="企业备注" prop="remark">
            <el-input type="textarea" size="mini" placeholder="请输入备注" v-model="formData.remark"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="float: right; margin-top: 0.4rem" size="mini"
              @click="submitCheckForm('formData')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
    <!-- 批量分配 -->
    <el-dialog title="批量分配" :visible.sync="batchOpenDialog" width="40%" :before-close="handleBatchShareClose">
      <div>
        <batch-allocate :multipleSelects="multipleSelects" @data-updated="handleRefresh"
          :clearCascader="shouldClearCascader"></batch-allocate>
      </div>
    </el-dialog>

    <el-drawer title="编辑" :visible.sync="editRowDrawer" direction="rtl" :before-close="handleEditRowDrawerBeforeClose"
      size="40%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-form :model="itemForm" ref="itemForm" label-width="150px" size="mini">
          <el-form-item label="是否核税">
            <el-radio-group v-model="itemForm.is_check_tax" size="mini">
              <el-radio label="1" border>是</el-radio>
              <el-radio label="0" border>否</el-radio>
              <el-radio label="2" border>异常</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否委托代账(静安)" style="white-space: nowrap">
            <el-radio-group v-model="itemForm.is_agent_acc_finance" size="mini">
              <el-radio label="1" border>是</el-radio>
              <el-radio label="0" border>否</el-radio>
            </el-radio-group>
            <span style="margin-left: 0.2rem">(奉贤)</span>
            <el-radio-group v-model="itemForm.is_trust_agent" size="mini">
              <el-radio label="1" border>是</el-radio>
              <el-radio label="0" border>否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否完成年报">
            <el-radio-group v-model="itemForm.annual_doned" size="mini">
              <el-radio label="1" border>是</el-radio>
              <el-radio label="2" border>否</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item label="是否委托代账(奉贤)">
            <el-radio-group v-model="itemForm.is_trust_agent" size="mini">
              <el-radio label="1" border>是</el-radio>
              <el-radio label="0" border>否</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item style="text-align: right">
            <el-button type="primary" @click="onAddSubmit">保 存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer title="网站信息" :visible.sync="webmDraw" direction="rtl" size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <resource-list-page-content :pageData="companyWebData" :cols="companyWebCols"  v-loading="webLoading"></resource-list-page-content>
      </div>
    </el-drawer>
  </el-container>
</template>

<script>
import SerMattIn from "common/ServiceMatterIn";
import MakePhone from "common/MakePhone";
import CompanyInfo from "common/CompanyInfo";
import CallLogs from "common/CallLogs";
import WxWorkChat from "common/WxWorkChat";
import UserwithOrder from "common/UserWithOrder";
import ChatRecord from "common/ChatRecord";
import QrCode from "common/QRcode";
import QrcodeLogo from "common/QRcodeLogo";
import DateFormatter from "common/DateFormatter";
import BatchAllocate from "./components/BatchAllocate";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';
import PhoneCom from "common/PhoneCom";
import EditInput from "./components/EditInput";
import ResourceListPageContent from 'common/ResourceListPageContent'

const regStatusOptions = ['存续', '在营（开业）', '停业', '吊销', '异常', '注销'];

export default {
  name: "Companies",
  components: {
    CompanyInfo,
    CallLogs,
    WxWorkChat,
    SerMattIn,
    UserwithOrder,
    ChatRecord,
    MakePhone,
    QrCode,
    QrcodeLogo,
    DateFormatter,
    BatchAllocate,
    PhoneCom,
    EditInput,
    ResourceListPageContent
  },
  data() {
    return {
      regStatusOptions: regStatusOptions,
      needEditStatus: [],
      lineFrom: "",
      needCid: null,
      itemForm: {
        id: null,
        is_check_tax: "0",
        is_agent_acc_finance: "0",
        annual_doned: null,
        is_trust_agent: "0"
      },
      checkType: this.$feedBackConfig.com_chat,
      valueList: [],
      QrCodeDialog: false,
      data_text: false,
      company_id_text: "",
      unCompanys: [],
      unAdminUsers: [],
      successNum: "",
      ShareImportInfo: false,
      salerResult: false,
      failedCompanies: [],
      failedUsers: [],
      successTotal: 0,
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      phoneFrom_phone: [],
      phoneFromDraw: false,
      provincesObj: {},
      cityObj: {},
      areaObj: {},
      areaparkObj: {},
      newComp: {
        id: "",
        policy_id: "",
        address_area: "",
      },
      handlePayerContentDrawer: false,
      ThreadData: {},
      userData: {},
      // 客户线索沟通记录弹窗
      chatRecordDrawer: false,
      // 沟通子组件传递的线索id
      threadId: null,
      PayerCompanyData: [],
      userOrderData: [],
      payerShowTab: "1",
      cName: null,
      cId: null,
      serviceInDrawer: false,
      searchArr: {
        company_from: null,
        company_name: "",
        satisfy: null,
        regStatus: [],
        is_check_tax: null,
        is_trust_agent: null,
        is_agent_acc_finance: null,
        saler_id: "",
        date_of_est: "",
        area_park: [],
        annual_doned: null,
        share_ids: [],
        finance_switch: [],
        business_licence: [],
        service_advisor_id: "",
        self_flag: "",
        web: ""
      },
      companyNameChange: false,
      shareOptions: [],
      visible: false,
      searchLoading: false,
      companies: [],
      areas: [],
      searchCompanies: [],
      // adminUsers: [],
      adminUsersLists: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 30, // 每页显示条数
      },
      customerDialogVisible: false,
      bindUserForm: {
        index: null,
        id: null,
        bindUserId: "",
      },
      selectBindUser: {
        name: "",
        phone: "",
      },
      bindDuckVisible: false,
      bindDuckForm: {
        index: null,
        id: null,
        name: "",
        phone: "",
      },
      logoUrl: require("../../assets/image/qyh-logo.jpg"),
      callLogsDrawer: false,
      company: "",
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      companyInfoDrawer: false,
      companyInfoId: null,
      bindWxDialogVisible: false,
      searchChatLoading: false,
      wxGroups: [],
      wxBindFrom: {
        companyId: null,
        groupId: null,
      },
      wxChatDrawer: false,
      wxWorkChatId: "",
      wxWorkchatCompany: "",
      col: [
        {
          label: "是否核税",
          prop: "is_check_tax",
          display: false,
        },
        {
          label: "是否委托代账(奉贤)",
          prop: "is_trust_agent",
          display: false,
        },
        {
          label: "是否委托代账(静安)",
          prop: "is_agent_acc_finance",
          display: false,
        },
        {
          label: "成立时间",
          prop: "date_of_est",
          display: false,
        },
        {
          label: "所属园区",
          prop: "address_park",
          display: false,
        },
        {
          label: "客户手机",
          prop: "customer_phone",
          display: false,
        },
        {
          label: "法人手机",
          prop: "legaler_contact",
          display: false,
        },
      ],
      switchOrCheckDrawer: false,
      formData: {
        id: "",
        orderComponents: [],
        company_id: null,
        company_name: "",
        // subsidiary_finance: null,
        is_zero_declare: "",
        remark: "",
      },
      searchOrderLoading: false,
      searchOrders: [],
      company_name_text: "",
      multipleSelects: [],
      batchOpenDialog: false,
      sharer: [],
      shouldClearCascader: false,
      rules: {
        // subsidiary_finance: [
        //   { required: true, message: "请选择所属财务", trigger: "blur" },
        // ],
      },
      orderNumRules: [{ required: true, message: "请输入订单编号", trigger: "blur" }],
      // serviceStartedAtRules: [
      //   { required: true, message: "请选择服务开始时间", trigger: "change" },
      // ],
      // serviceEndedAtRules: [
      //   { required: true, message: "请选择服务结束时间", trigger: "change" },
      // ],
      pickerMonthOptions: {
        shortcuts: [
          {
            text: "本月",
            onClick(picker) {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      editRowDrawer: false,
      user_id: null,
      webmDraw: false,
      webLoading: false,
      companyWebCols: [
        { label: '网站', prop: 'title', width: 120 },
        { label: '类型', prop: 'type' },
        { label: '状态', prop: 'status' },
        { label: '备案号', prop: 'bei_an', width: 180 },
        { label: '网址', prop: 'website', width: 180 },
        { label: '域名', prop: 'domain', width: 180 },
        { label: '审核日期', prop: 'check_date', width: 160 }
      ],
      companyWebData: []
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }

      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  filters: {
    dateFormat(value) {
      if (!value) return "";
      return value.split(" ")[0]; // 取日期部分
    },
  },
  methods: {
    loadShare() {
      this.$axios
        .get("api/api3_common_get_admin_user")
        .then(({ data }) => {
          if (data.code === 200) {
            this.shareOptions = data.data;
          }
        })
        .catch();
    },
    toEdit(lineValue, id) {
      this.lineFrom = "";
      this.needCid = null;
      this.needEditStatus = [];
      this.needEditStatus.push(id);
      this.needEditStatus[id] = true;
      this.$nextTick(() => {
        this.lineFrom = lineValue;
        this.needCid = id;
      });
    },
    doUpdateLine(lineValue, company_id) {
      console.log('Received updateLine event with lineValue:', lineValue, 'and company_id:', company_id);
      this.needEditStatus = [];
      this.companies.forEach((item) => {
        if (item.id === company_id) {
          item.company_from = lineValue;
        }
      });
      console.log('Updated companies:', this.companies);
    },
    revert() {
      this.needEditStatus = [];
    },
    refreshAnnual(row) {
      this.$axios
        .put("api/admin/companies/refresh_annual", {
          company_id: row.id,
        })
        .then(({ data }) => {
          if (data.code === 200) {
            row.annals_overd.push(data.data);
            row.visited_xlb_at = data.date;
            Object.assign(this.companies, row);
          } else {
            row.visited_xlb_at = data.date;
            Object.assign(this.companies, row);
            this.$message.warning(data.msg);
          }
        })
        .catch();
    },
    getCompanies() {
      this.$axios
        .get(
          "/api/admin/companies_new?page=" +
          this.pageOption.currentPage +
          "&pageSize=" +
          this.pageOption.pageSize +
          this.searchStr
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.companies = data.data.companies.data;
            this.pageOption.total = data.data.companies.total;
            this.pageOption.currentPage = data.data.companies.current_page;
            // this.adminUsers = data.data.adminUsers;
            this.adminUsersLists = data.data.adminUsersLists;
            this.areas = data.data.areas;
            this.user_id = data.data.uid;
            this.handelSetValueList(data.data.fields);
            this.handelSetCol();
            this.companyNameChange = false;
          }
        });
    },
    handleEditRow(row) {
      this.itemForm.is_check_tax = `${row.is_check_tax}`;
      this.itemForm.is_agent_acc_finance = `${row.is_agent_acc_finance}`;
      this.itemForm.is_trust_agent = `${row.is_trust_agent}`;
      this.itemForm.annual_doned = row.annals_overd.length ? "1" : "2";
      this.itemForm.id = row.id;
      this.editRowDrawer = true;
    },
    onAddSubmit() {
      this.$axios
        .post("/api/admin/company/update_tax", { form: this.itemForm })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.editRowDrawer = false;
            this.getCompanies();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    tableColumn(prop) {
      let width = "";
      if (
        prop === "customer_phone" ||
        prop === "legaler_contact" ||
        prop === "is_trust_agent" ||
        prop === "is_check_tax"
      ) {
        width = 180;
      } else if (prop === "date_of_est" || prop === "is_agent_acc_finance") {
        width = 200;
      }
      return width;
    },
    handelSetValueList(headers) {
      if (headers.length > 0) {
        this.valueList = headers;
        return;
      }
      for (var i = 0; i <= this.col.length; i++) {
        this.valueList.push(i);
      }
    },
    handleAddOrderComponents() {
      this.formData.orderComponents.push({
        order_num: "",
        service_started_at: "",
        service_ended_at: "",
      });
    },
    handleRemoveOrderComponents(index) {
      this.formData.orderComponents.splice(index, 1);
    },
    handelColCange(val) {
      this.$axios
        .post("/api/admin/company_new/set_field", { fields: val })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.handelSetCol();
            // 重新计算表格宽度  防止错位问题
            setTimeout(() => {
              this.$refs.company_table.doLayout();
            }, 100);
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handelSetCol() {
      for (var i = 0; i < this.col.length; i++) {
        if (this.valueList.indexOf(i) !== -1) {
          this.col[i].display = true;
        } else {
          this.col[i].display = false;
        }
      }
    },
    handleSignToTop(index, row) {
      this.$axios.get("/api/admin/handle_top?cid=" + row.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          this.getCompanies();
        } else {
          this.$message.error(data.msg);
        }
      });
    },

    // 发起交接
    handleSwitchCheckOpen(row) {
      this.formData.company_id = row.id;
      this.formData.company_name = row.company_name;
      this.company_name_text = row.company_name;
      this.$axios
        .get("/api/admin/tyc_order/get_com_order/?cid=" + row.id + "&type=1")
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            // this.$message.success(data.msg)
            this.formData.orderComponents = data.data.orders;
          } else {
            this.$message.error(data.msg);
          }
        });
      this.switchOrCheckDrawer = true;
    },
    closeSwitchOrCheckFromDrawer(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.switchOrCheckDrawer = false;
          this.formData.id = "";
          this.formData.orderComponents = [];
          this.formData.company_id = null;
          // this.formData.subsidiary_finance = null;
          this.formData.is_zero_declare = "";
          this.formData.remark = "";
          this.company_name_text = "";
          this.searchOrders = [];
          this.$refs["formData"].resetFields();
          done();
        })
        .catch((_) => { });
    },
    submitCheckForm(formName) {
      if (this.formData.orderComponents.length <= 0) {
        this.$message.error("请先新增订单信息！");
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/api/admin/company/switch_check", { formData: this.formData })
            .then((res) => {
              let { data } = res;
              if (data.code === 0) {
                this.getCompanies();
                this.switchOrCheckDrawer = false;
                this.$message.success(data.msg);

                this.formData.orderComponents = [];
                // this.formData.subsidiary_finance = null;
                this.formData.is_zero_declare = "";
                this.formData.remark = "";
              } else {
                this.$message.error(data.msg);
              }
            });
        } else {
          return false;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelects = val;
    },
    handleBatchSharer() {
      if (this.multipleSelects.length === 0) {
        this.$message.warning("请先勾选或全选条目!");
        return false;
      }
      this.batchOpenDialog = true;
    },
    handleRefresh() {
      this.getCompanies();
      this.batchOpenDialog = false;
    },
    handleBatchShareClose(done) {
      this.shouldClearCascader = true;
      done();
    },
    close_QrCodeDialog() {
      this.company_name_text = "";
      this.company_id_text = "";
    },
    createQrCode(company_name, company_id) {
      this.QrCodeDialog = true;
      this.$nextTick(() => {
        this.company_name_text = company_name;
        this.company_id_text = company_id;
      });
    },
    closeSelf() {
      this.unCompanys = [];
      this.unAdminUsers = [];
      this.successNum = "";
    },
    importedReturn(res) {
      if (res.code === 1) {
        this.unCompanys = res.data.unCompanys;
        this.unAdminUsers = res.data.unAdminUsers;
        this.successNum = res.data.success;
        this.ShareImportInfo = true;
      }
    },
    importedSalerReturn(res) {
      if (res.code === 0) {
        this.failedCompanies = res.data.failedCompanies;
        this.failedUsers = res.data.failedUsers;
        this.successTotal = res.data.successTotal;
        this.salerResult = true;
      } else {
        this.$message.error(res.msg);
      }
    },
    autoClose() {
      this.failedCompanies = [];
      this.failedUsers = [];
      this.successTotal = 0;
    },
    openPhoneFromDraw(phone) {
      setTimeout(() => {
        this.phoneFrom_phone.push(phone);
      });
      this.phoneFromDraw = true;
    },
    makePhone(phone) {
      let regPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;

      if (!regPhone.test(phone)) {
        this.$message.error("手机号格式错误");
        return;
      }

      this.$axios.post("/api/admin/call_logs/" + phone).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.$message.success("调用成功，请注意接听来电");
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    closePhoneFromDraw(done) {
      this.phoneFrom_phone = [];
      done();
    },
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    // 展示支付人信息及公司情况
    handleShowPayerContent(row) {
      this.ThreadData = row.customer.publicthread;
      this.userData = row.customer;
      this.PayerCompanyData = row.customer.company;
      if (this.PayerCompanyData.length !== 0) {
        for (let item of this.PayerCompanyData) {
          item.business_man = row.customer.business.username;
        }
      }
      this.handelOpenUserOrder(row.customer);
      this.handlePayerContentDrawer = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.PayerData = [];
          this.handlePayerContentDrawer = false;
          this.payerShowTab = "1";
          done();
        })
        .catch((_) => { });
    },
    // 控制用户关联订单信息展示与隐藏
    handelOpenUserOrder(row) {
      this.$axios.post("/api/customer/get_customer_order", { id: row.id }).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.userOrderData = data.data;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 打开当前客户手机号对应的沟通记录
    handleShowChatRecordOpen(threadId) {
      this.chatRecordDrawer = true;
      setTimeout(() => {
        this.threadId = threadId;
      });
    },
    // 关闭沟通记录弹窗
    handleChatRecordBeforeClose(done) {
      this.chatRecordDrawer = false;
      this.threadId = null;
      done();
    },
    handleEditRowDrawerBeforeClose(done) {
      this.itemForm.annual_doned = null;
      this.editRowDrawer = false;
      done();
    },
    resetForm(formName) {
      this.visible = false;
      this.$refs[formName].resetFields();
      this.pageOption.currentPage = 1;
      this.getCompanies();
    },
    submitForm(formName) {
      this.visible = false;
      this.pageOption.currentPage = 1;
      this.getCompanies();
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getCompanies();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getCompanies();
    },
    searchRemoteOrderMethod(query) {
      if (query !== "") {
        this.searchOrderLoading = true;
        setTimeout(() => {
          this.searchOrderLoading = false;
          this.searchArrItemOrders(query);
        }, 200);
      } else {
        this.searchOrders = [];
      }
    },
    searchArrItemOrders(query) {
      this.$axios
        .get("/api/admin/tyc_order/search_orders?order_num=" + query)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.searchOrders = data.data.orders;
          }
        });
    },
    searchRemoteCompanyMethod(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchArrItemCompanys(query);
        }, 200);
      } else {
        this.searchCompanies = [];
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompanies = data.data.companies;
        }
      });
    },
    handleSearchCompanyChange(val) {
      if (this.companyNameChange) return;
      this.orderNumChange = true;
      setTimeout(() => {
        this.pageOption.currentPage = 1;
        this.getCompanies();
      }, 800);
    },
    handleAreaChange() {
      this.pageOption.currentPage = 1;
      this.getCompanies();
    },
    // handleSearchSalerChange (val) {
    //   this.pageOption.currentPage = 1
    //   this.getCompanies()
    // },
    handelShow(index, row) {
      console.log(row);
    },
    handleOpenCustomer(index, id) {
      this.bindUserForm.id = id;
      this.bindUserForm.index = index;
      this.customerDialogVisible = true;
    },
    handleCustomerClose(done) {
      this.handleCustomerClear();
      done();
    },
    handleCustomerClear() {
      this.bindUserForm.id = null;
      this.bindUserForm.index = null;
      this.bindUserForm.bindUserId = "";
      this.selectBindUser.name = "";
      this.selectBindUser.phone = "";
    },
    handleBindUserChange(val) {
      if (val) {
        this.$axios
          .post("/api/admin/users/bindUserInfo", this.bindUserForm)
          .then((res) => {
            let { data } = res;
            if (data.code === 0) {
              this.selectBindUser.name = data.data.user.name;
              this.selectBindUser.phone = data.data.user.phone;
            } else {
              this.$message.error(data.msg);
            }
          });
      }
    },
    submitBindCustomer() {
      if (!this.bindUserForm.bindUserId) {
        this.$message.error("请输入客户id");
        return;
      }

      this.$axios.post("/api/admin/companies/bindUser", this.bindUserForm).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.companies[this.bindUserForm.index].customer = data.data.customer;
          this.companies[this.bindUserForm.index].customer_follow_pub =
            data.data.customerFollowPub;
          this.handleCustomerClear();
          this.$message.success(data.msg);
          this.customerDialogVisible = false;
        }
      });
    },
    handleOpenDocking(index, id) {
      this.bindDuckForm.index = index;
      this.bindDuckForm.id = id;
      this.bindDuckVisible = true;
    },
    clearBindDuckForm() {
      this.bindDuckForm.index = null;
      this.bindDuckForm.id = null;
      this.bindDuckForm.name = "";
      this.bindDuckForm.phone = "";
    },
    handleBindDuckClose(done) {
      this.clearBindDuckForm();
      done();
    },
    submitBindDuck() {
      if (!this.bindDuckForm.name) {
        this.$message.error("请输入服务对接人姓名");
        return;
      }

      if (!this.bindDuckForm.phone) {
        this.$message.error("请输入服务对接人手机号");
        return;
      }

      this.$axios.post("/api/admin/companies/bindDuck", this.bindDuckForm).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.companies[this.bindDuckForm.index].docking_name = this.bindDuckForm.name;
          this.companies[this.bindDuckForm.index].docking_phone = this.bindDuckForm.phone;
          this.clearBindDuckForm();
          this.bindDuckVisible = false;
        }
      });
    },
    handCallLogsOpen(row) {
      this.callLogsDrawer = true;
      setTimeout(() => {
        this.company = row.company_name;
        if (row.customer) this.callPhone.push(row.customer.phone);
        if (row.orders.length > 0) {
          for (let i = 0; i < row.orders.length; i++) {
            if (
              row.orders[i].customer_phone &&
              this.callPhone1.indexOf(row.orders[i].customer_phone) === -1
            ) {
              this.callPhone1.push(row.orders[i].customer_phone);
            }
            if (
              row.orders[i].corporate_phone &&
              this.callPhone2.indexOf(row.orders[i].corporate_phone) === -1
            ) {
              this.callPhone2.push(row.orders[i].corporate_phone);
            }
          }
        }
        if (row.docking_phone) this.callPhone3.push(row.docking_phone);
      });
    },
    handleCallLogsBeforeClose(done) {
      this.company = "";
      this.callPhone = [];
      this.callPhone1 = [];
      this.callPhone2 = [];
      this.callPhone3 = [];
      done();
    },
    handleCompanyInfoOpen(cid) {
      setTimeout(() => {
        this.companyInfoId = cid;
      }, 100);
      this.companyInfoDrawer = true;
    },
    handleCompanyInfoBeforeClose(done) {
      this.companyInfoId = null;
      done();
    },
    handBindWxgroupsOpen(cid) {
      this.$axios.get("/api/admin/company/group/" + cid).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.wxBindFrom.companyId = cid;
          this.wxBindFrom.groupId = data.data.chatId;
          if (data.data.chatId) {
            this.wxGroups.push({
              contact_wx_id: data.data.chatId,
              contact_nick_name: data.data.chatName,
            });
          }
          this.bindWxDialogVisible = true;
        }
      });
    },
    searchNameremoteMethod(query) {
      if (query !== "") {
        this.searchChatLoading = true;
        setTimeout(() => {
          this.searchChatLoading = false;
          this.searchChats(query);
        }, 200);
      } else {
        this.wxGroups = [];
      }
    },
    searchChats(query) {
      this.$axios.get("/api/admin/qy_wx_msg/search_groups/" + query).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.wxGroups = data.data;
        }
      });
    },
    handleBindWxClose(done) {
      this.wxBindFrom.companyId = null;
      this.wxBindFrom.groupId = null;
      this.wxGroups = [];
      done();
    },
    handleWxBindSub() {
      if (!this.wxBindFrom.companyId) {
        this.$message.error("请求错误，请刷新页面重试");
        return;
      }
      if (!this.wxBindFrom.groupId) {
        this.$message.error("请输入要绑定的群名！");
        return;
      }

      this.$axios.post("/api/admin/company/group", this.wxBindFrom).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.wxBindFrom.companyId = null;
          this.wxBindFrom.groupId = null;
          this.wxGroups = [];
          this.bindWxDialogVisible = false;
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleWxChatOpen(id, companyName) {
      this.wxWorkchatCompany = companyName;
      this.$nextTick(() => {
        this.wxChatDrawer = true;
        this.$axios.get("/api/admin/company/get_com_chat?id=" + id).then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.wxWorkChatId = data.data.chat.chat_id;
          }
        });
      });
    },
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkchatCompany = "";
      done();
    },
    serviceIn(row) {
      setTimeout(() => {
        this.cId = row.id;
        this.cName = row.company_name;
      });
      this.serviceInDrawer = true;
    },
    closeDrawer() {
      this.serviceInDrawer = false;
    },
    // 一键更换公司园区
    changeComPark() {
      this.$axios.post("/api/admin/company/change_address_park").then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    reloadTable() {
      this.getCompanies();
    },
    // 我的公司导出
    exportCompany() {
      // if (this.user_id !== 137) {
      //   // 指定人权限（唐佳伟）
      //   this.$message.error("暂无导出权限");
      //   return;
      // }
      this.$axios
        .post("api/admin/company/export_company", this.searchStr, {
          responseType: "blob",
        })
        .then(({ data }) => {
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = "我的公司.csv";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 10);
        })
        .catch((error) => {
          console.error(error);
          // if (error.response && error.response.data && error.response.data.message) {
          //     alert(error.response.data.message);
          //   } else {
          //     alert("导出失败，请稍后重试！");
          //   }
        });
    },
    handleKeyDown(event) {
      if (event.key === "Escape") {
        event.preventDefault();
        this.companyInfoDrawer = false;
      }
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    },
    showWebs(cid) {
      this.webmDraw = true
      this.webLoading = true
      this.$axios.get('/api/admin/company/webs?cid=' + cid, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.companyWebData = data.data.data
            this.webLoading = false
          }
        })
    }
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
  mounted() {
    this.getCompanies();
    window.addEventListener("keydown", this.handleKeyDown);
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

[v-cloak] {
  display: none;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.focus-input >>> .el-input__inner {
  padding: 0 8px !important;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}

.companies >>> .el-table__header th {
  color: #333333;
  background-color: #ECF4FF;
}

.companies {
  marginLeft();
  max-height: 100vh;
  .header-style {
    padding: 0px !important;
    height: 90px !important;
  }

  .main-style {
    padding: 0px !important;
    overflow-y: auto;
  }

  .footer-style {
    text-align: right;
    .el-pagination {
      padding-top: 15px;
    }
  }

  .count-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.tr {
  text-align: right;
}

.mt-10 {
  margin-top: 0.2rem;
}

.mt-20 {
  margin-top: 0.4rem;
}


.el-form .el-select {
  width: 100%;
}

.el-dialog .el-select {
  width: 70%;
}
.icon-class {
  width: 16px;
  margin-bottom: 0.06rem;
  margin-right: 0.1rem;
}

.AIdrawer {
  width: 800px; /* 设置遮罩层宽度为抽屉的宽度 */
}
.AIdrawerWrapper {
  width: 800px !important;
  margin-left: auto;
}

.count_style {
  display: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/companies/CompaniesNew.vue